import { useEffect, useRef } from 'react';

/**
 * Don't run on first render
 */
export default function useNotFirstRenderEffect(func: () => void, deps: any[]) {
    const didMount = useRef(false);

    useEffect(() => {
        if (didMount.current) func();

        didMount.current = true;
    }, deps);
}
